import React from 'react';
import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_baby3_subjects from './uganda_baby3_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_baby3 = ( ) => {
 
  return (
    <>
 <TopNavbar />
    <Uganda />
    <International_countries />
  <Uganda_baby3_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_baby3;
